"use strict";
/**
 * Read-only analytics metrics for script helpers (sync reads from a snapshot
 * refreshed by the backend before scene interpolation).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isGeneralAnalyticsFeedbackRow = isGeneralAnalyticsFeedbackRow;
/**
 * True when the row represents HQ / menu "general" feedback (not adventure-scoped).
 * Matches ingest from general feedback submit (adventureName `General`, sceneId `general_feedback`),
 * with legacy fallbacks when only one sentinel is present and adventureId is empty.
 */
function isGeneralAnalyticsFeedbackRow(row) {
    const aname = (row.adventureName ?? '').trim();
    const sid = (row.sceneId ?? '').trim();
    const aid = (row.adventureId ?? '').trim();
    if (aname === 'General' && sid === 'general_feedback') {
        return true;
    }
    if (aname === 'General' && !aid) {
        return true;
    }
    if (sid === 'general_feedback' && !aid) {
        return true;
    }
    return false;
}
//# sourceMappingURL=AnalyticsService.js.map